import React from "react";

export default function CampaignSelectItem(props) {
  const { campaign, onSelected } = props;

  return (
    <div className="campaign-pick pointer flex-it" onClick={() => onSelected(campaign)}>
      <span className="campaign-pick-circle circle-50">
        <img src={campaign.get("logo")} className="full-h" />
      </span>
      <h3 className="campaign-name--parent-select">{campaign.get("name")}</h3>
    </div>
  );
}
